/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import React, {ForwardedRef, forwardRef, useImperativeHandle, useState} from 'react';
import IDate from '@dvrd/idate';
import {ActivateHandle} from "../../../util/interfaces";
import CustomPeriod from "./customPeriod";

interface Props {
    onSubmit: (periodStart: IDate, periodEnd: IDate) => void;
    max?: IDate;
}

function CustomPeriodController(props: Props, ref: ForwardedRef<ActivateHandle>) {
    const {onSubmit, max} = props;
    const [periodStart, setPeriodStart] = useState<IDate | null>(null);
    const [periodEnd, setPeriodEnd] = useState<IDate | null>(null);
    const [active, setActive] = useState(false);

    function onActivate() {
        setActive(true);
    }

    function onClose() {
        setActive(false);
    }

    function onChange(key: 'end' | 'start') {
        return function (value: IDate) {
            if (key === 'end') setPeriodEnd(new IDate(value));
            else setPeriodStart(new IDate(value));
        }
    }

    function _onSubmit() {
        if (!periodStart || !periodEnd) return;
        onSubmit(periodStart, periodEnd);
        onClose();
    }

    useImperativeHandle(ref, () => ({activate: onActivate}));

    return (
        <CustomPeriod onChange={onChange} onClose={onClose} onSubmit={_onSubmit} periodStart={periodStart}
                      periodEnd={periodEnd} active={active} max={max}/>
    )
}

export default forwardRef<ActivateHandle, Props>(CustomPeriodController);